import { render, staticRenderFns } from "./DashAgenda.vue?vue&type=template&id=5a5b7ffc"
import script from "./DashAgenda.vue?vue&type=script&lang=js"
export * from "./DashAgenda.vue?vue&type=script&lang=js"
import style0 from "./DashAgenda.vue?vue&type=style&index=0&id=5a5b7ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports